export enum caseTypes {
    BEFORE = 'BEFORE',
    AFTER = 'AFTER',
    DURING_THE_DAY = 'DURING_THE_DAY'
};